var _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSetting(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "svg69",
    xmlSpace: "preserve",
    width: 682.66669,
    height: 682.66669,
    viewBox: "0 0 682.66669 682.66669",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs73"
  }, /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath83"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,512 H 512 V 0 H 0 Z",
    id: "path81"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "g75",
    transform: "matrix(1.3333333,0,0,-1.3333333,0,682.66667)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g77"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g79",
    clipPath: "url(#clipPath83)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g85",
    transform: "translate(256,334.6665)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c -43.446,0 -78.667,-35.22 -78.667,-78.667 0,-43.446 35.221,-78.666 78.667,-78.666 43.446,0 78.667,35.22 78.667,78.666 C 78.667,-35.22 43.446,0 0,0 Z m 220.802,-22.53 -21.299,-17.534 c -24.296,-20.001 -24.296,-57.204 0,-77.205 l 21.299,-17.534 c 7.548,-6.214 9.497,-16.974 4.609,-25.441 l -42.057,-72.845 c -4.889,-8.467 -15.182,-12.159 -24.337,-8.729 l -25.835,9.678 c -29.469,11.04 -61.688,-7.561 -66.862,-38.602 l -4.535,-27.213 c -1.607,-9.643 -9.951,-16.712 -19.727,-16.712 h -84.116 c -9.776,0 -18.12,7.069 -19.727,16.712 l -4.536,27.213 c -5.173,31.041 -37.392,49.642 -66.861,38.602 l -25.834,-9.678 c -9.156,-3.43 -19.449,0.262 -24.338,8.729 l -42.057,72.845 c -4.888,8.467 -2.939,19.227 4.609,25.441 l 21.3,17.534 c 24.295,20.001 24.295,57.204 0,77.205 l -21.3,17.534 c -7.548,6.214 -9.497,16.974 -4.609,25.441 l 42.057,72.845 c 4.889,8.467 15.182,12.159 24.338,8.729 l 25.834,-9.678 c 29.469,-11.04 61.688,7.561 66.861,38.602 l 4.536,27.213 c 1.607,9.643 9.951,16.711 19.727,16.711 h 84.116 c 9.776,0 18.12,-7.068 19.727,-16.711 l 4.535,-27.213 c 5.174,-31.041 37.393,-49.642 66.862,-38.602 l 25.835,9.678 c 9.155,3.43 19.448,-0.262 24.337,-8.729 L 225.411,2.911 c 4.888,-8.467 2.939,-19.227 -4.609,-25.441 z",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 40,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path87"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSetting);
export default __webpack_public_path__ + "static/media/setting.546055f1fe33dcc597c8a96f1932faad.svg";
export { ForwardRef as ReactComponent };